import { styled, css } from 'styled-components'
import { onMediumScreen, onSmallScreen } from 'mixtiles-web-common'
import Button from 'mixtiles-web-common/ui/Button'
import {
  ButtonStyling,
  type ButtonStylingProps,
} from '../../mixtiles-web-common/ui/Button/Button.styles'

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  user-select: none;
  padding-bottom: 40px;

  ${onSmallScreen()} {
    min-width: 400px;
  }

  ${onMediumScreen()} {
    width: 475px;
    padding-bottom: 0;
  }
`

type ImageWrapperProps = {
  $dualOption: boolean
  $secondaryText: boolean
}

export const ImageWrapper = styled.div<ImageWrapperProps>`
  width: 220px;
  height: 220px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin: ${({ $dualOption }) => ($dualOption ? '8px 0 4px' : '7px 0 3px')};
  ${({ $dualOption, $secondaryText }) => {
    if ($dualOption) {
      return css`
        margin: 8px 0 4px;
      `
    }
    if ($secondaryText) {
      return css`
        margin: 7px 0 3px;
      `
    }
    return css`
      width: 236px;
      height: 165px;
      margin: 47px 0 14px;
    `
  }}
`

export const Image = styled.img`
  max-width: 100%;
  max-height: 100%;
`

type TitleProps = {
  $dualOption: boolean
  $secondaryText: boolean
  $addMargin: boolean
  $titleMaxWidth: number | undefined
}

export const Title = styled.div<TitleProps>`
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 28px;
  white-space: pre-line;

  ${({ $addMargin }) =>
    $addMargin &&
    css`
      margin-top: 31px;
    `}

  ${({ $titleMaxWidth }) =>
    $titleMaxWidth &&
    css`
      max-width: ${$titleMaxWidth}px;
    `}


  ${({ $secondaryText }) =>
    $secondaryText &&
    css`
      line-height: 1.2;
      margin-bottom: 12px;
    `}

  ${({ $dualOption, $secondaryText }) => {
    if ($dualOption) {
      return css`
        width: 265px;
        line-height: 29px;
        ${onMediumScreen()} {
          width: 285px;
        }
      `
    }
    if (!$dualOption && !$secondaryText) {
      return css`
        font-size: 22px;
        line-height: 140%;
      `
    }
  }}
`

export const Subtitle = styled.div`
  color: ${({ theme }) => theme.colors.black};
  width: 319px;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 21px;
  margin-bottom: 40px;
`

type ApproveButtonProps = {
  $dualOption: boolean
}

const ApproveStyling = css<ApproveButtonProps>`
  ${({ $dualOption }) => {
    if (!$dualOption) {
      return css`
        margin-bottom: 48px;
      `
    }
  }}
`

export const ApproveWrapper = styled.div<
  ApproveButtonProps & ButtonStylingProps
>`
  ${ButtonStyling};
  ${ApproveStyling};
`

export const ApproveButton = styled(Button)<ApproveButtonProps>`
  ${ApproveStyling};
  padding: 0 22px;
`

export const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.grayDark};
  -webkit-tap-highlight-color: transparent;

  svg {
    width: 24px;
    height: 24px;
  }
`

export const DismissButton = styled.div`
  text-align: center;
  width: 285px;
  font-size: 16px;
  line-height: 21px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black};
  margin: 23px auto 31px;
  text-decoration: underline;
  cursor: pointer;
`
